import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Permission } from 'anchor-shared/lib/model/entity/permission';

@Injectable()
export class PermissionDAO extends BaseDAO<Permission> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.PERMISSION);
  }

  //todo - RM manager

  public getEditablePermissions(): Permission[] {
    throw Error('no impl getEditablePermissions()');
  }
}
